module.exports = __webpack_public_path__ + "static/media/logoDark.00edd922.gif";